import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Navbar from "./Layouts/Navbar/Navbar";
import Footer from "./Layouts/Footer/Footer";
import Home from "./Pages/Home/Home";
import About from "./Pages/About/About";
import Contact from "./Pages/Contact/Contact";
import Services from "./Pages/Services/Services";
import Products from "./Pages/Products/Products";
import Gallery from "./Pages/Gallery/Gallery";
import Modules from "./Pages/Modules/Modules";
import Sidebar from "./MyAdminStar/Layouts/Sidebar";
import Topbar from "./MyAdminStar/Layouts/Topbar";
import Dashboard from "./MyAdminStar/Dashboard/Dashboard";
import AdminLogin from "./MyAdminStar/AdminLogin/AdminLogin";
import HomepageImage from "./MyAdminStar/HomePageImages/HomepageImage";
import AProducts from "./MyAdminStar/Products/Products";
import AServices from "./MyAdminStar/Services/Services";
import AModules from "./MyAdminStar/Modules/Modules";
import AGallery from "./MyAdminStar/Gallery/Gallery";
import AContact from "./MyAdminStar/Contact/Contact";
import Inquiry from "./MyAdminStar/Inquiry/Inquiry";
import ScrollToTop from "./ScrollToTop";
import Team from "./MyAdminStar/Team/Team";
import CompanyPartners from "./MyAdminStar/Companylogo/Company";
import Youtube from "./MyAdminStar/Youtube/Youtube";
import Profile from "./MyAdminStar/Profile/Profile";
import Changepass from "./MyAdminStar/ChangePass/Changepass";
import AAbout from "./MyAdminStar/Aboutus/About";

function AdminProtectedRoute({ children }) {
  const isLoggedIn = sessionStorage.getItem("admin_logged_in");
  const adminId = sessionStorage.getItem("admin_id");
  const adminUsername = sessionStorage.getItem("admin_username");

  if (isLoggedIn !== "true" || !adminId || !adminUsername) {
    return <Navigate to="/MyAdminStar/login" replace />;
  }

  return children;
}

function ClientLayout() {
  return (
    <>
      <ScrollToTop />

      <Navbar />

      <div className="content">
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Products />} />
          <Route path="/gallery" element={<Gallery />} />

          <Route path="/modules" element={<Modules />} />
          <Route path="/products/:product" element={<Products />} />

          <Route path="/products/:product/:category" element={<Products />} />
        </Routes>
      </div>

      <Footer />
    </>
  );
}

function AdminLayout() {
  return (
    <div className="admin-container">
      <AdminProtectedRoute>
        <Sidebar />

        <div className="admin-main">
          <Topbar />

          <main className="admin-content">
            <Routes>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="products" element={<AProducts />} />
              <Route path="homepageimages" element={<HomepageImage />} />
              <Route path="services" element={<AServices />} />
              <Route path="modules" element={<AModules />} />
              <Route path="gallery" element={<AGallery />} />
              <Route path="contacts" element={<AContact />} />
              <Route path="teams" element={<Team />} />
              <Route path="/MyAdminStar/inquiry" element={<Inquiry />} />
              <Route path="inquiry" element={<Inquiry />} />
              <Route path="profile" element={<Profile />} />
              <Route path="change-password" element={<Changepass />} />
              <Route path="youtube-videos" element={<Youtube />} />
              <Route path="company-clients" element={<CompanyPartners />} />
              <Route path="about" element={<AAbout />} />
              <Route
                path="*"
                element={<Navigate to="/MyAdminStar/dashboard" replace />}
              />
            </Routes>
          </main>
        </div>
      </AdminProtectedRoute>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/MyAdminStar/login" element={<AdminLogin />} />

        <Route path="/MyAdminStar/*" element={<AdminLayout />} />

        <Route path="/*" element={<ClientLayout />} />
      </Routes>
    </Router>
  );
}
